module.exports = __webpack_public_path__ + "img/精致面具--多种款式.aa5b9ab6.png";